import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f6f5f1]">
        <Loader2 className="h-6 w-6 animate-spin text-[#0f172a]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
